import { Drawer, Group } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { IconPlus } from "@tabler/icons-react"
import { Button } from "@tfg/ui"
import { queryClient } from "~/backend/queryClient"
import { findAllActivitiesQueryKey, useCreateActivity } from "~/gen/api"

import {
  fields,
  reactFormConfig,
} from "~/pages/Admin/Ingestion/Activities/createForm.config"
import { TypesForm } from "~/pages/Admin/components/TypesForm"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export function ActivityCreation() {
  const [drawerOpen, drawerActions] = useDisclosure(false)

  const { mutate: createActivity } = useCreateActivity({
    mutation: {
      onSuccess: async () => {
        drawerActions.close()
        await queryClient.invalidateQueries({
          queryKey: findAllActivitiesQueryKey(),
        })
        showSuccessNotification({
          title: "Added",
          message: "Successfully added activity",
        })
      },
      onError: (error) => {
        showAxiosError({
          defaultMessage: "Failed to add activity",
          showNotification: true,
          error,
        })
      },
    },
  })

  return (
    <>
      <Group justify="right">
        <Button onClick={drawerActions.open} icon={<IconPlus />}>
          New Activity
        </Button>
      </Group>
      <Drawer
        position="right"
        opened={drawerOpen}
        onClose={() => drawerActions.close()}
        title="Create an Activity"
        size="lg"
      >
        <TypesForm
          elements={fields}
          submitLabel="Create"
          formConfig={reactFormConfig}
          mutate={(data) => createActivity({ data })}
        />
      </Drawer>
    </>
  )
}
